import {
  AllegroFullImpliedWarranty,
  AllegroImpliedWarranty,
} from '../../../../../api/allegro/impliedwarranty/impliedWarrantyTypes';

export interface Edit {
  label: string;
  individualPeriod: string;
  corporatePeriod: string;
  name: string;
  street: string;
  postCode: string;
  city: string;
  countryCode: string | null;
  description: string;
}

export type Status = 'loading' | 'ready' | 'saving';

export interface State {
  status: Status;
  edit: Edit;
  impliedWarranty?: AllegroFullImpliedWarranty;
}

type EditSetAction = { type: 'edit/set', payload: Edit };
type StatusSetAction = { type: 'status/set', payload: Status };
type ImpliedWarrantySetAction = {
  type: 'impliedWarranty/set',
  payload: AllegroFullImpliedWarranty
};
export type Action = EditSetAction | StatusSetAction | ImpliedWarrantySetAction;

const initialEdit: Edit = {
  label: '',
  individualPeriod: '',
  corporatePeriod: '',
  name: '',
  street: '',
  postCode: '',
  city: '',
  countryCode: null,
  description: '',
};

function getEdit(impliedWarranty: AllegroFullImpliedWarranty): Edit {
  const { address } = impliedWarranty;

  return {
    label: impliedWarranty.name,
    individualPeriod: impliedWarranty.individual?.period ?? '',
    corporatePeriod: impliedWarranty.corporate?.period ?? '',
    name: address?.name ?? '',
    street: address?.street ?? '',
    postCode: address?.postCode ?? '',
    city: address?.city ?? '',
    countryCode: address?.countryCode ?? null,
    description: impliedWarranty.description ?? '',
  };
}

export function getInitialState(impliedWarranty?: AllegroImpliedWarranty): State {
  return {
    status: impliedWarranty ? 'loading' : 'ready',
    edit: initialEdit,
    impliedWarranty: undefined,
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'edit/set': {
      return { ...state, edit: action.payload };
    }
    case 'status/set': {
      return { ...state, status: action.payload };
    }
    case 'impliedWarranty/set': {
      return {
        ...state,
        status: 'ready',
        impliedWarranty: action.payload,
        edit: getEdit(action.payload),
      };
    }
    default:
      return state;
  }
}
